import React from 'react'
import { useVehiclesWithDocsQuery, CardType } from '@edge/spark/io-dashboards'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import { BasicWidgetProps } from '../../types'

const VehiclesWithDocuments = ({
    config: { text = 'Vehicles with', text2 = `Documents` },
    widgetId,
    handleConfig,
    readonly,
}: BasicWidgetProps): React.ReactElement => {
    const { data, loading } = useVehiclesWithDocsQuery()

    const totalDocCount = data?.auction?.document?.vehiclesWithDocs?.totalDocCount || '0'

    const vehiclesWithDocsCount = data?.auction?.document?.vehiclesWithDocs?.vehiclesWithDocsCount || '0'

    const totalDocs = `${totalDocCount} Total Documents`

    return (
        <SingleNumberWidget
            cardType={CardType.VEHICLE}
            // actionText="View Vehicles"
            // actionLink="/weneedthislink"
            number={vehiclesWithDocsCount}
            loading={loading}
            text={text}
            text2={text2}
            secondaryText={totalDocs}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default VehiclesWithDocuments
